export const getVariantName = (product) => {
  return product.product.variants?.filter(
    (eachVariant) => eachVariant._id === product.variant
  )[0].variantName;
};
